import React, { useState, useContext, useEffect, useCallback } from 'react'
import DashboardMain_Kratos from '../DashboardMain_Kratos/DashboardMain_Kratos'
import * as $ from 'jquery'
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_kratos'
import useHttp from '../../../hook/use-http'
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_kratos'
import AppContext from '../../../store/AppContext'

import "./Driveanalysis_Kratos.css"
import TwoChartTemplate_Kratos from "./TwoChartTemplate_Kratos";
import SingleBoxRange_Kratos from './SingleBoxRange_Kratos'
import SingleSoc_Kratos from './SingleSoc_Kratos'
import Topkpis_Kratos from './Topkpis_Kratos'
import TopFiveSection_Kratos from './TopFiveSection_Kratos'
import Filter_Kratos from './Filter_Kratos'
import PageSecond_Kratos from './PageSecond_Kratos'
import AvgDischargeDuration_Kratos from './AvgDischargeDuration_Kratos'
import SocDischargeCycle_Kratos from './SocDischargeCycle_Kratos'
import NetEnergyConsumption_Kratos from './NetEnergyConsumption_Kratos'
import EnergyBoxRange_Kratos from "./EnergyBoxRange_Kratos"
import NetEnergyConsumptionkwh_Kratos from './NetEnergyConsumptionkwh_Kratos'
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice"
import { decodeToken } from 'react-jwt';

export default function Driveanalysis_Kratos() {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE

  const [gloablfilter, setGloablfilter] = useState(sampleObj)
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);
  const [chartType, setChartSelected] = useState('netenergy')
  const [chartTypeBox, setChartBoxSelected] = useState('netenergybox')
  const log_data = (data) => {
  }

  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "driveanalysis_kratos"

      }
    }, log_data)
  }, []);

  const filterSubmited = useCallback((data) => {
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
  }

  const pageChange = () => {
    setGloablfilter((prevdata) => {
      return { ...prevdata, pageSelected: 1, VIN_NUM: [] }
    });
  }

  const onreset = (data) => {
    setGloablfilter(data);
  }

  const filterHideShow = () => {
    $("#filterSearch").toggle("slow");
  }

  const changeNet = (selectedOption) => {
    setChartSelected(selectedOption)

  }
  const changeNetBox = (selectedOption) => {
    setChartBoxSelected(selectedOption)

  }
  const loggedInUser = useSelector(selectLoggedInUser);

  if (gloablfilter.pageSelected === 1) {
    return (

      <DashboardMain_Kratos>
        <Filter_Kratos onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} />
        <div className="container-fluid kratosdrpg1">
          <Topkpis_Kratos gloablfilter={gloablfilter} />
          <section className="graphs kratosdrpg1">
            <div className="row">
              <div className="col-md-12 col-sm-12 col-lg-3 mb-3">
                <div id="wrapper" className="toggled">
                  <div id="page-content-wrapper">
                    <TopFiveSection_Kratos singleVinSelected={singleVinSelected} gloablfilter={gloablfilter}></TopFiveSection_Kratos>
                  </div>
                </div>
              </div>

              <div className="col-md-12 col-sm-12 col-lg-9">

                <div className="row mb-3" style={{}}>
                  <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-lg-4 col-md-4 col-sm-12' : 'col-lg-6 col-md-4 col-sm-12')}>
                    <SingleBoxRange_Kratos title="Real World Range Boxplot" gloablfilter={gloablfilter} apiend="rangebarchart"></SingleBoxRange_Kratos>
                  </div>
                  <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-lg-4 col-md-4 col-sm-12' : 'col-lg-6 col-md-4 col-sm-12')}>
                    <SingleSoc_Kratos title="Real World Range Distribution" gloablfilter={gloablfilter} apiend="rangebarchart"></SingleSoc_Kratos>
                  </div>
                  {
                    loggedInUser.flagForHideShow === "ERC" &&
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <AvgDischargeDuration_Kratos title="Average discharge duration" gloablfilter={gloablfilter} apiend="avgdischargeduration"></AvgDischargeDuration_Kratos>
                    </div>
                  }
                </div>
                <div className="row mb-3" style={{}}>

                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="v-title chartbox chartbox_kratos">
                      <div className="titlebg_kratos text-fit">Net Energy Consumption</div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeNet(event.target.value)}
                          value={chartType}>
                          <option value="netenergy">kWh/km</option>
                          <option value="netkwh">kWh</option>
                        </select>
                      </div>
                      {
                        (chartType === "netenergy") ?
                          <NetEnergyConsumption_Kratos gloablfilter={gloablfilter} apiend="netenergyconsumption" type={chartType}></NetEnergyConsumption_Kratos>
                          : <NetEnergyConsumptionkwh_Kratos title="Net Energy" gloablfilter={gloablfilter} apiend="netenergykwh" type={chartType}></NetEnergyConsumptionkwh_Kratos>

                      }
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="v-title chartbox chartbox_kratos">
                      <div className="titlebg_kratos text-fit p-2">Net Energy Boxplot</div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeNetBox(event.target.value)}
                          value={chartTypeBox}>
                          <option value="netenergybox">kWh/km</option>
                          <option value="netkwhbox">kWh</option>
                        </select>
                      </div>
                      {
                        (chartTypeBox === "netenergybox") ?
                          <EnergyBoxRange_Kratos title="Net Energy" gloablfilter={gloablfilter} apiend="netenergyconsumption"></EnergyBoxRange_Kratos>
                          : <EnergyBoxRange_Kratos title="Net Energy" gloablfilter={gloablfilter} apiend="netenergykwh"></EnergyBoxRange_Kratos>
                      }
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <SocDischargeCycle_Kratos title="SoC Discharge/Cycle Analysis" gloablfilter={gloablfilter} apiend="socdichargecycle"></SocDischargeCycle_Kratos>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </DashboardMain_Kratos>
    )
  } else {
    return (
      <DashboardMain_Kratos>
        <PageSecond_Kratos gloablfilter={gloablfilter} pageChange={pageChange} />
      </DashboardMain_Kratos>
    );
  }
}